import { StyleSheet } from 'aphrodite';
import { THEME } from '../../Theme/theme';

const { colors, spacing, common, typography, queries } = THEME;

export const s = StyleSheet.create({
	popup: {
		maxWidth: 600,
		width: '90vw',
		maxHeight: '90vh',
		height: 700,
		display: 'flex',
		flexDirection: 'column',
		padding: spacing.none,
		borderRadius: common.borderRadius,
		[queries.md]: {
			width: '95vw',
			height: '90vh',
		},
	},
	header: {
		borderBottom: common.border,
		padding: `${spacing.md}px ${spacing.lg}px`,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: spacing.sm,
		flexShrink: 0,
		margin: 0,
	},
	headerStart: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
	},
	leoAvatar: {
		width: spacing.xxl,
		height: spacing.xxl,
	},
	headerTitle: {
		fontSize: typography.fontSizes.md,
		lineHeight: '1.5rem',
		fontWeight: typography.fontWeights.bold,
		margin: spacing.none,
	},
	body: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		padding: spacing.none,
	},
	conversation: {
		flex: 1,
		paddingLeft: spacing.lg,
		...common.scrollBar,
	},
	conversationContent: {
		paddingRight: spacing.lg,
		...common.scrollBar,
	},
	inputContainer: {
		boxSizing: 'border-box',
		padding: spacing.lg,
		flexShrink: 0,
	},
	errorBoundaryDisplay: {
		gap: spacing.md,
	},
	errorMessage: {
		color: colors.primary.main,
	},
	spacer: {
		boxSizing: 'border-box',
		height: spacing.lg,
	},
	sparklesIcon: {
		color: colors.primary.main,
	},
});
